/**
 * HomeCTA — Diyaar Ma Tahay Inaad Kobciso Ganacsigaaga? (CTA Section)
 *
 * Qaybta ugu dambeysa ee bogga — Card leh gradient text + WhatsApp button
 *
 * Waxaad ka bedeli kartaa:
 *  - Heading-ka "Diyaar Ma Tahay..." (line 26-31)
 *  - Subtitle-ka (line 33-36)
 *  - Highlight chips-ka 3 (line 8-12)
 *  - WhatsApp URL-ka (line 47)
 *  - Button text-ka "Nala Soo Xiriir Hada" (line 50)
 */
import { motion } from "framer-motion";
import { MessageCircle, Sparkles, Zap, Shield } from "lucide-react";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";

/* Highlight chips — halkan ku dar ama ka badal */
const highlights = [
  { icon: Zap, text: "Daqiiqado gudahood bilow" },
  { icon: Shield, text: "Kaadh lacag ma loo baahna" },
  { icon: Sparkles, text: "Taageero 24/7" },
];

export default function HomeCTA() {
  return (
    <section id="cta" className="py-20 sm:py-24 border-t border-border gradient-border-top section-glow">
      <div className="mx-auto max-w-2xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Card className="relative overflow-hidden p-8 sm:p-10 text-center">
            {/* Subtle gradient glow behind card */}
            <div
              className="absolute inset-0 opacity-[0.04] pointer-events-none"
              style={{
                background: "radial-gradient(ellipse at 50% 0%, #4f7df5 0%, transparent 70%)",
              }}
            />

            <div className="relative">
              {/* ── Heading ── */}
              <h2 className="font-heading text-2xl sm:text-3xl font-bold text-navy tracking-tight">
                Diyaar Ma Tahay Inaad
                <br />
                <span className="bg-gradient-to-r from-[#4f7df5] to-[#7c5cf5] bg-clip-text text-transparent">
                  Kobciso Ganacsigaaga?
                </span>
              </h2>

              {/* ── Subtitle ── */}
              <p className="mt-3 text-sm text-muted max-w-md mx-auto leading-relaxed">
                Ku biir ganacsiyada Soomaaliyeed ee nala shaqeeya GanacsiHub.
              </p>

              {/* ── Highlight chips ── */}
              <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
                {highlights.map((h) => {
                  const Icon = h.icon;
                  return (
                    <div
                      key={h.text}
                      className="inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-3 py-1.5"
                    >
                      <Icon className="h-3 w-3 text-accent" />
                      <span className="text-xs font-medium text-navy">{h.text}</span>
                    </div>
                  );
                })}
              </div>

              {/* ── WhatsApp CTA button ── */}
              <div className="mt-8">
                <Button size="lg" className="gap-2 w-full sm:w-auto" asChild>
                  {/* Badal WhatsApp URL-ka halkan */}
                  <a
                    href="https://wa.me/252619150114"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <MessageCircle className="h-4 w-4" />
                    Nala Soo Xiriir Hada
                  </a>
                </Button>
              </div>
            </div>
          </Card>
        </motion.div>
      </div>
    </section>
  );
}
